import styled from 'styled-components'

type StyledProps = { edit?: boolean; isProcessing?: boolean }

const StyledUpdateCardInfo = styled.div<StyledProps>`
  margin: 25px 0;

  .card-info-header {
    font-family: ${({ theme }) => theme.fonts.nunito};
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .button-container {
    margin-bottom: -1px;

    button {
      padding: 0;
    }

    .cancel {
      color: #a8a8a8;
    }

    .save {
      padding-left: 14px;
      height: fit-content;
    }
  }

  .card-info-container {
    font-family: ${({ theme }) => theme.fonts.nunito};
    color: ${({ theme }) => theme.colors.gray[700]};

    display: ${({ edit }) => (edit ? 'block;' : 'flex;')};
    align-items: center;
    padding: ${({ edit }) => (edit ? '18px 16px 16px 16px' : '30px')};
    box-sizing: border-box;
    margin-top: 11px;

    height: 110px;
    background-color: rgba(235, 235, 235, 0.5);
    border-radius: 10px;
    border: ${({ edit, isProcessing }) =>
    (edit && !isProcessing ? '1.5px solid #3FAE9A;' : '1px solid #ebebeb;')};

    .card-info-empty-state {
      display: grid;
      justify-content: center;
      grid-gap: 1rem;
      font-weight: 600;
      place-content: center;
      place-items: center;
    }

    .spinner {
      margin-top: 15px;
    }

    .card-input-wrap {
      ${({ isProcessing }) => isProcessing && 'display: none;'}
    }

    .edit-view-header {
      padding-bottom: 10px;
      font-size: 15px;
    }

    .card-info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-weight: 500;
      width: 100%;
      max-width: 550px;
      text-transform: capitalize;

      .card-logo {
        width: 36px;
        height: 36px;
        position: relative;
        margin-right: 1rem;
      }

      .card-name {
        font-size: 16px;
      }

      img {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .input-error {
      margin-top: 1px;
      font-size: 13px;
    }
  }

  .edit,
  .save,
  .cancel {
    cursor: pointer;
  }

  .edit,
  .save,
  .cancel,
  .loading {
    color: ${({ theme }) => theme.colors.green[300]};
    font-family: ${({ theme }) => theme.fonts.lexend};
    font-weight: 400;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 1px;

    border: 0;
    background: transparent;
  }
`

export default StyledUpdateCardInfo
